"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskTypeLabel = exports.TaskType = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
// eslint-disable-next-line no-shadow
var TaskType;
(function (TaskType) {
    TaskType["DIGEST_DAILY"] = "digest-daily";
    TaskType["DIGEST_WEEKLY"] = "digest-weekly";
    TaskType["EVENTBRIDGE_SETUP"] = "eventbridge-setup";
    TaskType["ELASTIC_REINIT"] = "elastic-reinit";
    TaskType["ELASTIC_POPULATE"] = "elastic-populate";
    TaskType["ELASTIC_POPULATEORG"] = "elastic-populateorg";
    TaskType["ELASTIC_POPULATEOPS"] = "elastic-populateops";
    TaskType["ELASTIC_POPULATEISSUES"] = "elastic-populateissues";
    TaskType["OP_PROCESSOPS"] = "op-processops";
    TaskType["OP_PROCESSOPSORG"] = "op-processopsorg";
    TaskType["OP_PROCESSOPSLATE"] = "op-processopslate";
    TaskType["OP_PROCESSOPSDUE"] = "op-processopsdue";
    TaskType["OP_PROCESSOPSMISSED"] = "op-processopsmissed";
    TaskType["OP_GENERATEDETAILPDF"] = "op-generatedetailpdf";
    TaskType["OP_GENERATEISSUES"] = "op-generateissues";
    TaskType["ISSUE_GENERATEDETAILPDF"] = "issue-generatedetailpdf";
    TaskType["ISSUE_PROCESSISSUES"] = "issue-processissues";
    TaskType["ISSUE_PROCESSISSUESORG"] = "issue-processissuesorg";
    TaskType["ISSUE_PROCESSISSUESMISSED"] = "issue-processissuesmissed";
    TaskType["WORKFLOW_PROCESSSCHEDULED"] = "workflow-processscheduled";
    TaskType["WORKFLOW_PROCESSSCHEDULEDORG"] = "workflow-processscheduleorg";
    TaskType["TASK_PURGE"] = "task-purge";
    TaskType["IMPORT_ETL"] = "import-etl";
    TaskType["IMPORT_DRYLOAD"] = "import-dryload";
    TaskType["IMPORT_LOAD"] = "import-load";
    TaskType["IMPORT_TRANSFORM"] = "import-transform";
    TaskType["EXPORT_EXTRACT"] = "export-extract";
    TaskType["EXPORT_EXTRACTBATCH"] = "export-extractbatch";
    TaskType["EXPORT_GROUP_DETAIL_PDF"] = "export-group-detail-pdf";
    TaskType["EXPORT_DASHBOARD_PDF"] = "export-dashboard-pdf";
    TaskType["ORG_PURGE"] = "org-purge";
    TaskType["ORG_DELETE"] = "org-delete";
    TaskType["ONBOARDING_ABANDONED"] = "onboarding-abandoned";
    TaskType["DBA_RUNSQL"] = "dba-runsql";
    TaskType["DBA_MIGRATE"] = "dba-migrate";
    TaskType["DBA_MIGRATE_PER_ENTITY"] = "dba-migrate-per-entity";
    TaskType["DBA_PRIVATISE"] = "dba-privatise";
    TaskType["IQM_CREATE_WORKFLOW"] = "iqm-create-workflow";
    TaskType["IQM_UPLOAD_OP_PDF_REPORT"] = "iqm-upload-op-pdf-report";
    TaskType["IQM_POLL_ENABLED_ORGS"] = "iqm-poll-enabled-orgs";
    TaskType["IQM_POLL_ORG_ISSUES"] = "iqm-poll-org-issues";
    TaskType["IQM_POLL_ISSUE"] = "iqm-poll-issue";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
exports.default = TaskType;
function taskTypeLabel(type) {
    switch (type) {
        case TaskType.DIGEST_DAILY:
            return lib_i18n_1.default.t('digest-daily');
        case TaskType.DIGEST_WEEKLY:
            return lib_i18n_1.default.t('digest-weekly');
        case TaskType.EVENTBRIDGE_SETUP:
            return lib_i18n_1.default.t('eventbridge-setup');
        case TaskType.ELASTIC_REINIT:
            return lib_i18n_1.default.t('elastic-reinit');
        case TaskType.ELASTIC_POPULATE:
            return lib_i18n_1.default.t('elastic-populate');
        case TaskType.ELASTIC_POPULATEORG:
            return lib_i18n_1.default.t('elastic-populateorg');
        case TaskType.ELASTIC_POPULATEOPS:
            return lib_i18n_1.default.t('elastic-populateops');
        case TaskType.ELASTIC_POPULATEISSUES:
            return lib_i18n_1.default.t('elastic-populateissues');
        case TaskType.OP_PROCESSOPS:
            return lib_i18n_1.default.t('op-processops');
        case TaskType.OP_PROCESSOPSORG:
            return lib_i18n_1.default.t('op-processopsorg');
        case TaskType.OP_PROCESSOPSLATE:
            return lib_i18n_1.default.t('op-processopslate');
        case TaskType.OP_PROCESSOPSDUE:
            return lib_i18n_1.default.t('op-processopsdue');
        case TaskType.OP_PROCESSOPSMISSED:
            return lib_i18n_1.default.t('op-processopsmissed');
        case TaskType.OP_GENERATEDETAILPDF:
            return lib_i18n_1.default.t('op-generatedetailpdf');
        case TaskType.OP_GENERATEISSUES:
            return lib_i18n_1.default.t('op-generateissues');
        case TaskType.ISSUE_GENERATEDETAILPDF:
            return lib_i18n_1.default.t('issue-generatedetailpdf');
        case TaskType.ISSUE_PROCESSISSUES:
            return lib_i18n_1.default.t('issue-processissues');
        case TaskType.ISSUE_PROCESSISSUESORG:
            return lib_i18n_1.default.t('issue-processissuesorg');
        case TaskType.ISSUE_PROCESSISSUESMISSED:
            return lib_i18n_1.default.t('issue-processissuesmissed');
        case TaskType.TASK_PURGE:
            return lib_i18n_1.default.t('task-purge');
        case TaskType.IMPORT_ETL:
            return lib_i18n_1.default.t('import-etl');
        case TaskType.IMPORT_DRYLOAD:
            return lib_i18n_1.default.t('import-dryload');
        case TaskType.IMPORT_LOAD:
            return lib_i18n_1.default.t('import-load');
        case TaskType.IMPORT_TRANSFORM:
            return lib_i18n_1.default.t('import-transform');
        case TaskType.EXPORT_EXTRACT:
            return lib_i18n_1.default.t('export-extract');
        case TaskType.EXPORT_EXTRACTBATCH:
            return lib_i18n_1.default.t('export-extractbatch');
        case TaskType.EXPORT_GROUP_DETAIL_PDF:
            return lib_i18n_1.default.t('export-group-detail-pdf');
        case TaskType.ORG_PURGE:
            return lib_i18n_1.default.t('org-purge');
        case TaskType.ORG_DELETE:
            return lib_i18n_1.default.t('org-delete');
        case TaskType.ONBOARDING_ABANDONED:
            return lib_i18n_1.default.t('onboarding-abandoned');
        case TaskType.DBA_RUNSQL:
            return lib_i18n_1.default.t('dba-runsql');
        case TaskType.DBA_MIGRATE:
            return lib_i18n_1.default.t('dba-migrate');
        case TaskType.DBA_MIGRATE_PER_ENTITY:
            return lib_i18n_1.default.t('dba-migrate-per-entity');
        case TaskType.DBA_PRIVATISE:
            return lib_i18n_1.default.t('dba-privatise');
        case TaskType.WORKFLOW_PROCESSSCHEDULED:
            return lib_i18n_1.default.t('workflow-processscheduled');
        case TaskType.WORKFLOW_PROCESSSCHEDULEDORG:
            return lib_i18n_1.default.t('workflow-processscheduledorg');
        case TaskType.IQM_CREATE_WORKFLOW:
            return lib_i18n_1.default.t('iqm-create-workflow');
        case TaskType.IQM_UPLOAD_OP_PDF_REPORT:
            return lib_i18n_1.default.t('iqm-upload-op-pdf-report');
        case TaskType.IQM_POLL_ENABLED_ORGS:
            return lib_i18n_1.default.t('iqm-poll-enabled-orgs');
        case TaskType.IQM_POLL_ORG_ISSUES:
            return lib_i18n_1.default.t('iqm-poll-org-issues');
        case TaskType.IQM_POLL_ISSUE:
            return lib_i18n_1.default.t('iqm-poll-issue');
    }
}
exports.taskTypeLabel = taskTypeLabel;
